import MapaAprobacion from './mapa-aprobacion.vue';
import Error403 from './../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import PermisosEmpleados from './../empleados/permisos.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';

// El acceso real lo garantiza el backend (403 a quien no sea ADMIN/DIRECTOR, decisión I3 de
// la #47) y la entrada de menú bajo Ajustes, que es el control de acceso de las rutas: el
// listado de roles de aquí solo actúa como respaldo cuando todavía no hay menú cargado.
//
// [#65, 02/10/2026] Entra por la barrera de usuario actualizado: tanto el acceso como el enlace a
// la ficha del empleado se deciden con el `Usuario.me()` de esta carga, no con el menú que quedó
// guardado de la sesión anterior. El porqué, en `barreraUsuarioActualizado.js`.
const routes = [
    {
        path: '/mapaaprobacion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: conUsuarioActualizado(function(routeTo) {
            if (!RoutesUtils.tieneAcceso(routeTo.path, ['ADMIN', 'DIRECTOR'])) {
                return { component: Error403 };
            }
            // La pregunta la contesta el módulo de empleados y no esta pantalla: son los mismos
            // argumentos que su ruta, y con la lista copiada aquí el enlace y la página podían
            // decir cosas distintas —DIRECTOR entra en la ficha aunque el módulo no esté en su
            // menú, que es como se llega a ella desde aquí—. Cuatro copias de la misma pregunta
            // es lo que falló en la revisión #1711.
            return {
                component: MapaAprobacion,
                props: { puedeAbrirFicha: PermisosEmpleados.abrirFicha() }
            };
        }),
        keepAlive: true
    }
];
export default routes;
